module.exports = __webpack_public_path__ + "19971e1c9e5246a3b7269df2407bf458.fbx";